import { sharingSteps } from './ProjectSharing';
import { ProjectSharingHeader } from './ProjectSharingHeader';
import { facebookShareUrl, openNewWindow } from '../../utils';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import styles from './project-sharing.module.less';
import { ProjectSharingFooter } from './ProjectSharingFooter';
import { MarkAsCompleteButton } from './ProjectSharingMarkAsComplete';
import { getUrlFromShortlink } from '../../shortlink/shortlink-model';
import RoundedButtonSecondary from '../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import Image from '../../components/image/Image';

export const ProjectSharingFacebook = ({ setSharingStepComplete, project, completed, shortlink }) => {
    const urlToShare = shortlink ? getUrlFromShortlink(shortlink) : `https://spleis.no/${project.id}`;
    const facebookUrl = facebookShareUrl(urlToShare);
    const footerBackLink = `/project/${project.id}/sharing/1`;
    const footerBackLinkText = 'Personlig lenke';
    const footerForwardLink = `/project/${project.id}/sharing/3`;
    const footerForwardLinkText = 'Støttespillere';
    return (
        <>
            <ProjectSharingHeader
                title="Del på Facebook"
                backLink={`/project/${project.id}/sharing`}
                backLinkText="Tilbake til delingspanelet"
            />
            <section className={styles.contentPanel}>
                <Image
                    className={styles.topImage}
                    src="people-illustrations/man-sending-invitation.svg"
                    title="Person som inviterer vennene sine med mobiltelefonen"
                    alt="Person som inviterer vennene sine med mobiltelefonen"
                />
                <ul className={styles.checkmarkList}>
                    <li>Innsamlinger som deles i sosiale medier har mye større sannsynlighet for å lykkes</li>
                    <li>
                        De fleste som støtter spleisen din vil trolig være i din umiddelbare eller utvidede vennekrets
                    </li>
                    <li>Husk å oppfordre til å dele videre &ndash; det hjelper!</li>
                </ul>
                <div className={styles.shareButton}>
                    <RoundedButtonSecondary
                        className={styles.maxWidthOnMobile}
                        onClick={() => {
                            trackEvent('admin', 'project-share', {
                                channel: 'facebook',
                                activity: 'facebook',
                                'project-id': project.id,
                            });
                            openNewWindow(facebookUrl);
                        }}
                    >
                        <i className={`fab fa-facebook-f ${styles.buttonIcon}`} aria-hidden="true" /> Del på Facebook
                    </RoundedButtonSecondary>
                </div>
                <MarkAsCompleteButton
                    completed={completed}
                    onClick={() => {
                        setSharingStepComplete(sharingSteps.facebook);
                        trackEvent('shareguide', 'step-complete', {
                            activity: 'facebook',
                            'project-id': project.id,
                        });
                    }}
                />
            </section>
            <ProjectSharingFooter
                backLink={footerBackLink}
                backLinkText={footerBackLinkText}
                forwardLink={footerForwardLink}
                forwardLinkText={footerForwardLinkText}
            />
        </>
    );
};
